export type TipoResultadoBusca =
  | 'Página'
  | 'Serviço'
  | 'Categoria de serviço'
  | 'Notícia'
  | 'Manifestação';

export const TIPOS_RESULTADO_BUSCA: TipoResultadoBusca[] = [
  'Página',
  'Serviço',
  'Categoria de serviço',
  'Notícia',
  'Manifestação'
];

export interface ResultadoBusca {
  id: string;
  titulo: string;
  descricao: string;
  tipo: TipoResultadoBusca;
  modulo: string;
  icone: string;
  rota: string;
  parametros?: Record<string, string>;
  termos?: string[];
  atualizadoEm?: string;
}

export interface GrupoResultadoBusca {
  tipo: TipoResultadoBusca;
  itens: ResultadoBusca[];
}

export interface ConsultaBuscaGlobal {
  termo: string;
  tipo?: string | null;
  modulo?: string | null;
  limite?: number;
}

export interface RespostaBuscaGlobal {
  termo: string;
  total: number;
  itens: ResultadoBusca[];
}
